/**
 * @param {string} text
 */
export const copyTextToClipboard = (text) => {
    navigator.clipboard.writeText(text);
}
